module.exports = __webpack_public_path__ + "img/graph.fda6511c.jpg";